export const length_validation = {
    host_file_number: `Host file number must not exceed 30 characters.`,
    application_number: `Application umber must not exceed 30 characters.`,
    title: `Title must not exceed 250 characters.`,
    correspondence_customer_no: `correspondence customer number must not exceed 10 characters.`,
    confirmation_number: `confirmation number must not exceed 30 characters.`,
    pct_application_no: `pct application number must not exceed 30 characters.`,
    patent_number: `patent number must not exceed 30 characters.`,
    deposit_acc_no: `Deposit account number must not exceed 50 characters.`
};